import { render } from "./TesterPortal.vue?vue&type=template&id=74a36f93"
import script from "./TesterPortal.vue?vue&type=script&lang=js"
export * from "./TesterPortal.vue?vue&type=script&lang=js"

import "./TesterPortal.vue?vue&type=style&index=0&id=74a36f93&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__